import {environment, isHybridApp} from '@/config/environment';
import {Capacitor} from '@capacitor/core';
import {appConfig} from '@/config/appConfig';

/**
 * Gets the authentication redirect URL for the current platform.
 *
 * For hybrid apps, uses a unified URL scheme format: {appId}://{path}
 * - MSAL/Azure: dev.deskly.app://msauth
 * - OIDC: dev.deskly.app://login
 *
 * @param path - Path ('msauth' for Azure/Microsoft, 'login' for OIDC)
 * @returns The redirect URL
 */
export function getAuthenticationRedirectUrl(path: 'msauth' | 'login'): string {
    if (!isHybridApp) {
        // Use dev url for local development (*.local domains)
        if (appConfig.isLocalDevelopment) {
            return environment.VITE_DEV_BASE_URL!;
        }

        return window.location.origin;
    }

    const platform = Capacitor.getPlatform();

    if (platform === 'ios') {
        const bundleId = environment.VITE_IOS_BUNDLE_ID;
        if (!bundleId) {
            throw new Error('VITE_IOS_BUNDLE_ID is not defined in environment variables');
        }
        return `${bundleId}://${path}`;
    }

    if (platform === 'android') {
        const packageId = environment.VITE_ANDROID_PACKAGE_ID;
        if (!packageId) {
            throw new Error('VITE_ANDROID_PACKAGE_ID is not defined in environment variables');
        }
        return `${packageId}://${path}`;
    }

    // Fallback for web or unknown platforms
    return window.location.origin;
}
